module.exports = __webpack_public_path__ + "img/FISKE.433175cd.jpg";